import React, { useState } from "react";

const Navbar = () => {
  const navItems = [
    { title: "Accueil", path: "/" },
    { title: "Faire un don 💜", path: "/#don" },
    { title: "Devenir partenaire", path: "/devenir-partenaire" },
  ];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="fixed w-full bg-color4 z-[1000] py-2">
      <nav className="flex items-center container mx-auto px-4 py-1 sm:px-6 lg:px-10 h-16">
        {/* Logo */}
        <div className="flex-shrink-0">
          <a
            href="/"
            className="font-bold lg:text-4xl text-3xl hover:text-color6 text-color2 font-archivo"
          >
            Thrundrz
          </a>
        </div>

        {/* Desktop menu */}
        <div className="hidden lg:flex flex-1 justify-center">
          <ul className="flex items-center gap-8 text-color2">
            {navItems.map(({ title, path }) => (
              <li
                key={title}
                className="font-bold font-archivo text-md hover:text-color6 cursor-pointer"
              >
                <a href={path}>{title}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Desktop button */}
        {/* Desktop button */}
        <div className="hidden lg:flex items-center gap-2 flex-shrink-0">
          <a
            href="/devenir-partenaire"
            className="w-auto text-center font-bold font-archivo text-md 
               text-color2 bg-color6 rounded-lg px-4 py-2 
               hover:bg-color1 transition cursor-pointer"
          >
            Espace Créateur
          </a>
        </div>


        {/* Mobile hamburger */}
        <div className="lg:hidden flex items-center ml-auto">
          <button onClick={toggleMenu} className="text-color2 focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className={`lg:hidden w-full absolute top-20 left-0 z-[1000] 
          bg-yellow-500 rounded-b-2xl overflow-hidden
          transition-all duration-500 ease-in-out
          ${isMenuOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}`}
      >
        <ul className="flex flex-col items-center gap-4 py-6 text-color4">
          {navItems.map(({ title, path }) => (
            <li
              key={title}
              className="font-bold font-archivo tracking-widest text-xl hover:text-color5 cursor-pointer"
            >
              <a href={path} onClick={closeMenu}>
                {title}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex flex-col items-center gap-3 mb-6">
          <a
            href="/devenir-partenaire"
            className="w-auto text-center font-bold font-archivo text-md text-color2 bg-color4 rounded-lg px-3 py-2 hover:bg-color5/45 hover:text-color2 transition cursor-pointer"
          >
            Créateurs d'événements ?
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;